import React from 'react';
import PropTypes from 'prop-types';

import InputGroup from '~components/forms/inputs/Field';
import Label from '~components/forms/Label';
import * as Yup from 'yup';

export const DateOfBirthBlockSchema = {
  month_of_birth: Yup.number()
    .positive()
    .integer()
    .required('Required')
    .min(1, 'Must be a month number between 1 and 12')
    .max(12, 'Must be a month number between 1 and 12')
    .typeError('Must be a valid month number'),
  day_of_birth: Yup.number()
    .positive()
    .integer()
    .required('Required')
    .min(1, 'Must be a valid date')
    .max(31, 'Must be a valid date')
    .typeError('Must be a valid date'),
  year_of_birth: Yup.date()
    .required('Required')
    .min(1900, 'Must be later than 1899')
    .max(new Date().getFullYear(), 'Must not be in the future')
    .typeError('Must be a valid year'),
};

export function MonthOfBirthField({ errors, required, isSubfield }) {
  return (
    <InputGroup
      name='month_of_birth'
      label='Month'
      autoComplete='bday-month'
      extraLabelledBy='label__date-of-birth'
      inputMode='numeric'
      errors={errors}
      required={required}
      isSubfield={isSubfield}
      placeholder='MM'
      inputMask='00'
    />
  );
}

MonthOfBirthField.propTypes = {
  errors: PropTypes.object.isRequired,
  required: PropTypes.bool,
  isSubfield: PropTypes.bool,
};

export function DayOfBirthField({ errors, required, isSubfield }) {
  return (
    <InputGroup
      name='day_of_birth'
      label='Day'
      autoComplete='bday-day'
      extraLabelledBy='label__date-of-birth'
      inputMode='numeric'
      errors={errors}
      required={required}
      isSubfield={isSubfield}
      placeholder='DD'
      inputMask='00'
    />
  );
}

DayOfBirthField.propTypes = {
  errors: PropTypes.object.isRequired,
  required: PropTypes.bool,
  isSubfield: PropTypes.bool,
};

export function YearOfBirthField({ errors, required, isSubfield }) {
  return (
    <InputGroup
      name='year_of_birth'
      label='Year'
      autoComplete='bday-year'
      extraLabelledBy='label__date-of-birth'
      inputMode='numeric'
      errors={errors}
      required={required}
      isSubfield={isSubfield}
      placeholder='YYYY'
      inputMask='0000'
    />
  );
}

YearOfBirthField.propTypes = {
  errors: PropTypes.object.isRequired,
  required: PropTypes.bool,
  isSubfield: PropTypes.bool,
};

function DateOfBirthBlock({ errors, required }) {
  return (
    <div>
      <Label id='label__date-of-birth'>Date of birth</Label>
      <div className='mr-60 flex shrink-0 grow-0 flex-row gap-3'>
        <div className='w-20 flex-none'>
          <MonthOfBirthField errors={errors} required={required} isSubfield />
        </div>
        <div className='w-20 flex-none'>
          <DayOfBirthField errors={errors} required={required} isSubfield />
        </div>
        <div className='w-28 flex-none'>
          <YearOfBirthField errors={errors} required={required} isSubfield />
        </div>
      </div>
    </div>
  );
}

DateOfBirthBlock.propTypes = {
  errors: PropTypes.object.isRequired,
  required: PropTypes.bool,
};

export default DateOfBirthBlock;
